import type {
  ApiKeyContract,
  CreateApiKeyRequest,
  CreatedApiKeyContract,
} from '@nest-react/domain';

type ApiRequest = <T>(path: string, options?: RequestInit) => Promise<T>;

export interface DeveloperApiRepository {
  list: (workspaceId: string) => Promise<ApiKeyContract[]>;
  create: (
    workspaceId: string,
    input: CreateApiKeyRequest
  ) => Promise<CreatedApiKeyContract>;
  revoke: (workspaceId: string, id: string) => Promise<ApiKeyContract>;
}

export const createDeveloperApiRepository = (
  request: ApiRequest
): DeveloperApiRepository => ({
  list: (workspaceId: string): Promise<ApiKeyContract[]> =>
    request<ApiKeyContract[]>(`/workspaces/${workspaceId}/api-keys`),
  create: (
    workspaceId: string,
    input: CreateApiKeyRequest
  ): Promise<CreatedApiKeyContract> =>
    request<CreatedApiKeyContract>(`/workspaces/${workspaceId}/api-keys`, {
      method: 'POST',
      body: JSON.stringify(input),
    }),
  revoke: (workspaceId: string, id: string): Promise<ApiKeyContract> =>
    request<ApiKeyContract>(`/workspaces/${workspaceId}/api-keys/${id}`, {
      method: 'DELETE',
    }),
});
